import { render, staticRenderFns } from "./UPCTransactionReport.vue?vue&type=template&id=dc178fcc"
import script from "./UPCTransactionReport.vue?vue&type=script&lang=js"
export * from "./UPCTransactionReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports